module.exports = __webpack_public_path__ + "img/C08TechKarma_ua.c53775a4.webp";